// import FullLogo from "@/assets/FullLogo";
// import Illustration1 from "@/assets/Illustration1";
// import Illustration2 from "@/assets/Illustration2";
// import Illustration3 from "@/assets/Illustration3";
import FullLogo from "../../assets/FullLogo";
import Illustration1 from "../../assets/Illustration1";
import Illustration2 from "../../assets/Illustration2";
import Illustration3 from "../../assets/Illustration3";
import useScreenHook from "../../utils/helperFunctions/useScreenHook";

const renderDesktopLoginScreen = (children: any) => (
  <div className="flex items-center justify-center h-screen bg-gray-100">
    <div>
      <div className="flex justify-center items-center mb-[104px]">
        <FullLogo width={"322"} height={"64"} />
      </div>

      <div className="p-8 bg-white shadow-[0_10px_40px_rgba(0,0,0,0.3)] rounded-lg max-w-[480px] relative">
        <div className="absolute top-[-53px]">
          <Illustration2 />
        </div>
        <div className="absolute right-[-221px] top-[-111px] ">
          <Illustration3 />
        </div>
        <div className="absolute left-[-216px] bottom-[-4px] ">
          <Illustration1 />
        </div>
        <div className="flex justify-center mb-6">
          {/* Add your logo here */}
          <span className="text-black dark:red text-[28px] font-poppins font-bold break-words">
            Dashboard
          </span>
        </div>

        {children}
      </div>
    </div>
  </div>
);

const renderMobileLoginScreen = (children: any) => (
  <div className="flex items-center justify-center w-full h-screen">
    <div className="bg-[#F1F4F9]">
      <div className="p-8 bg-[#F1F4F9] shadow-[0_10px_40px_rgba(0,0,0,0.3)] rounded-lg max-w-[480px] relative">
        <div className="absolute top-[-29px] right-[1px]">
          <Illustration2 width="46px" height="44.87px" />
        </div>
        <div className="absolute right-[-13px] top-[500px] ">
          <Illustration3 width="98px" height="81px" />
        </div>
        <div className="absolute left-[9px] bottom-[-123px] ">
          <Illustration1 width="89px" height="98px" />
        </div>
        <div className="flex flex-col justify-center items-center mb-6 gap-8">
          {/* Add your logo here */}
          <div className="flex justify-center items-center ">
            <FullLogo width={"172"} height={"39"} />
          </div>
          <span className="text-black dark:red text-[18px] font-poppins font-bold break-words">
            Dashboard
          </span>
        </div>

        {children}
      </div>
    </div>
  </div>
);

export default function LoginDashBoard(props: { children: React.ReactNode }) {
  const { deviceType = "desktop" } = useScreenHook();
  return (
    <>
      {deviceType === "desktop"
        ? renderDesktopLoginScreen(props.children)
        : renderMobileLoginScreen(props.children)}
    </>
  );
}
